module.exports = __webpack_public_path__ + "img/synapse-homepage2.a3be12dd.png";